export default __webpack_public_path__ + "static/media/prp.183902d9.pdf";